import { render, staticRenderFns } from "./RepairSppOrderTask.vue?vue&type=template&id=edb50e06&"
import script from "./RepairSppOrderTask.vue?vue&type=script&lang=js&"
export * from "./RepairSppOrderTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports